<div class="row dashboard-mainn" (resized)="onResized($event)">
	<div class="col-xl-3 col-lg-6 col-md-6 col-12">
	  <div class="card gradient-purple-love">
		<div class="card-content">
		  <div class="card-body py-0">
			<div class="media pb-1">
			  <div class="media-body white text-left">
				<h3 class="font-large-1 white mb-0">
				  {{usersLength}}
				</h3>
				<span>Total Users</span>
			  </div>
			  <!-- <div class="media-right white text-right">
				<i class="ft-activity font-large-1"></i>
			  </div> -->
			</div>
		  </div>
		  <div
			id="Widget-line-chart"
			class="WidgetlineChart WidgetlineChartshadow mb-2"
		  >
			<x-chartist
			  class="height-75"
			  [type]="WidgetlineChart.type"
			  [options]="WidgetlineChart.options"
			  [responsiveOptions]="WidgetlineChart.responsiveOptions"
			  [events]="WidgetlineChart.events"
			>
			</x-chartist>
		  </div>
		</div>
	  </div>
	</div>
	<div class="col-xl-3 col-lg-6 col-md-6 col-12">
	  <div class="card gradient-ibiza-sunset">
		<div class="card-content">
		  <div class="card-body py-0">
			<div class="media pb-1">
			  <div class="media-body white text-left">
				<h3 class="font-large-1 white mb-0">
				  {{ studentLength }}
				</h3>
				<span>Total Students</span>
			  </div>
			  <!-- <div class="media-right white text-right">
				<i class="ft-percent font-large-1"></i>
			  </div> -->
			</div>
		  </div>
		  <div
			id="Widget-line-chart"
			class="WidgetlineChart WidgetlineChartshadow mb-2"
		  >
			<x-chartist
			  class="height-75"
			  [type]="WidgetlineChart1.type"
			  [options]="WidgetlineChart1.options"
			  [responsiveOptions]="WidgetlineChart1.responsiveOptions"
			  [events]="WidgetlineChart1.events"
			>
			</x-chartist>
		  </div>
		</div>
	  </div>
	</div>
  
	<div class="col-xl-3 col-lg-6 col-md-6 col-12">
	  <div class="card gradient-mint">
		<div class="card-content">
		  <div class="card-body py-0">
			<div class="media pb-1">
			  <div class="media-body white text-left">
				 <h3 class="font-large-1 white mb-0">{{businessLength}}</h3> 
				<span> Total Business</span>
			  </div>
			  <!-- <div class="media-right white text-right">
				<i class="ft-trending-up font-large-1"></i>
			  </div> -->
			</div>
		  </div>
		  <div
			id="Widget-line-chart"
			class="WidgetlineChart WidgetlineChartshadow mb-2"
		  >
			<x-chartist
			  class="height-75" 
			>
			</x-chartist>
		  </div>
		</div>
	  </div>
	</div>
	<div class="col-xl-3 col-lg-6 col-md-6 col-12">
	  <div class="card gradient-king-yna">
		<div class="card-content">
		  <div class="card-body py-0">
			<div class="media pb-1">
			  <div class="media-body white text-left">
				<h3 class="font-large-1 white mb-0">{{courseCount}}</h3>
				<span>Total Course</span>
			  </div>
			  <!-- <div class="media-right white text-right">
				<i class="ft-credit-card font-large-1"></i>
			  </div> -->
			</div>
		  </div>
		  <div
			id="Widget-line-chart"
			class="WidgetlineChart WidgetlineChartshadow mb-2"
		  >
			<x-chartist
			  class="height-75"
			  [type]="WidgetlineChart3.type"
			  [options]="WidgetlineChart3.options"
			  [responsiveOptions]="WidgetlineChart3.responsiveOptions"
			  [events]="WidgetlineChart3.events"
			>
			</x-chartist>
		  </div>
		</div>
	  </div>
	</div>
	<section class="latest_static_card">
		
		<div class="row">
			<div class="col-lg-6 col-md-6 col-sm-12" *ngFor="let course of default_courses">
				<div class="card">
					<div class="card-content">
						<div class="card-image">
							<img class="card-img-top img-fluid" src="assets/course-img.png" alt="Card image cap">
							<div class="card_content_title position_to_be_absolute">
								<h6>{{course?.title}}</h6>
							</div>
						</div>
						<div class="card-body">
							<div class="price_full_radius">
								<a>{{course?.total_fees | currency:'INR'}}</a>
							</div>
							<div class="card_content_main">
								<p>{{course?.course_category[0]?.displayname}}</p>
							</div>
							<div class="card_content_title">
								<h6>{{course?.title}}</h6>
							</div>
							<div class="card_content_rating">
								<div class="rating_stars">
									<i class="ft-star-on"></i>
									<i class="ft-star-on"></i>
									<i class="ft-star-on"></i>
									<i class="ft-star-on"></i>
									<i class="ft-star-on"></i>
								</div>
								<div class="rating_count">
									<span>(0/5 Ratings)</span>
								</div>
							</div>
							<div class="card_course_name">
								<p [innerHTML]="course?.about|slice:0:125"></p>
							</div>
							<div class="card_course_meta">
								<ul>
									<li class="mr-15px"><i class="ft-list"></i> English</li>
									<li> <i class="ft-user"></i> <span>Online</span></li>
								</ul>
							</div>
							<div class="custom_button_card">
								<button class="btn btn-primary"
									 [routerLink]="['/learn/learn-by-course',course?.slug]">Learn</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
	  <div class="col-12">
		<div #dynamicContainer></div>
		<div class="card">
		  <div class="card-content">
			<div class="card-body">
			  <div class="col-12">
				<h5 class="mb-2 text-bold-500">
				  <i></i> 
				</h5>
				<ngx-charts-bar-vertical
				  [view]="view"
				  [scheme]="colorScheme"
				  [results]="barChartData"
				  [gradient]="gradient"
				  [xAxis]="showXAxis"
				  [yAxis]="showYAxis"
				  [legend]="showLegend"
				  [showXAxisLabel]="showXAxisLabel"
				  [showYAxisLabel]="showYAxisLabel"
				  [yAxisLabel]="yAxisLabel">
				</ngx-charts-bar-vertical>
				<div *ngIf="!transactionData">Data Not Found</div>
			  </div>
			</div>
		  </div>
		</div>
	  </div>
	
  </div>



